import { createContext } from 'react';

const OrganizationContext = createContext({});

export default OrganizationContext;
